import React, { useEffect } from "react";
import Accordion from "./Accordions";
import Navigation from "../Components/Navigation/Navigation";
import "../Accordions/Accordions.css";
import Footer from "../Components/Navigation/Footer";
import Banner from "../Components/Banner";
import ImageFAQ from "../Assets/Images/Banner/faqs.jpg";

function Faqs() {
  const vendors = [
    {
      title: "How long does the whole selling process take?",
      content:
        "There is no specific time frame of how long the process can take, it varies from property to property and the circumstances of all parties involved. In normal cases it can take usually 8-12 weeks on freehold properties and roughly around 12-16 weeks on leasehold properties.",
    },
    {
      title: "What documents are required for me to sell my property?",
      content: "You will need to provide a certified copy of your ID (passport, driving license), proof of address, land registry documents or mortgage statement that you own the property. You will be required to sign an Agency Agreement (Terms of business) to officially instruct an agent to sell.",
    },
    {
      title: "What do I need to do to get my property ready to market?",
      content: "We encourage you to ensure your property is decluttered, clean, tidy, presentable and ready for professional pictures. This allows viewers to navigate through the property, giving the best presentation of your home in achieving the best possible price. You can also consider arranging an interior designer to dress the property to attract prospective buyers.",
    },
    {
      title: "Would I be liable to pay any tax when selling a property?",
      content: "There are two types of tax you will be liable to pay, Capital Gains Tax (profit you have made in the duration of your ownership to when you sell) (Capital Gains Tax Link) and the other being Inheritance Tax (A certain part of the sale proceeding will go to the government upon selling your property) (Inheritance Tax Link).",
    },
    {
      title: "What is the process between exchange and completion?",
      content: "Once your lawyer has finalized the file this will require you to send over a minimum of 10% deposit in order for contracts to be exchanged (once done this will be the point of no return) Once contracts have exchanged your lawyer will request the remaining funds to be sent from you in order to complete the transaction  (if buying with a mortgage funds will be requested from your lender to the lawyer).",
    },
    {
      title: "Do you have a solicitor that I can use?",
      content: "Yes, we have a range of solicitors that we can refer to you and obtain a quote on your behalf, which then you can liaise directly to confirm fees and instruct accordingly for your property transaction.",
    },
  ];

  const buyers = [
    {
      title: "How much deposit am I required to put down?",
      content: "A minimum of 10% deposit is required to buy a property, however the more you put down means you will reduce your mortgage repayments.",
    },
    {
      title: "After viewing the property how do I submit my offer?",
      content: "All offers must be submitted in writing and emailed to us to start negotiations on your behalf with the seller.",
    },
    {
      title: "How long does the referencing process take?",
      content: "This can normally take up to 3 working days subject to all relevant documents being submitted efficiently.",
    },
    {
      title: "At what point do I need to sign the tenancy agreement?",
      content: "Once your reference checks have been completed, you will receive a copy of the tenancy agreement. The tenancy agreement will need to be signed on or before the start date of the contract. Once all parties have signed the tenancy agreement you will then receive a set of keys to your new home.",
    },
    {
      title: "What happens to my security deposit? ",
      content: "If you are moving into one of our managed properties, your deposit will be registered in a deposit protection scheme. You will also receive a copy of your deposit certificate within the first week of your tenancy.",
    },
    {
      title: "What do I need to earn per year to secure a property?",
      content: "All tenants will need to earn a combined salary of 2.5 times the annual rent to be eligible and qualified to secure a property.",
    },
  ];

  const tenants = [
    {
      title: "How long does the letting process take?",
      content: "This can take 7-10 days, depending on how quickly documents are submitted, and how quickly our referencing company responds to inquiries and a satisfactory outcome.",
    },
    {
      title: "How much deposit am I required to put down to secure a property?",
      content: "By law you are only required to pay one week’s deposit to have the property secured for yourself.",
    },
    {
      title: "How long does the referencing process take?",
      content: "This can normally take up to 3 working days subject to all relevant documents being submitted efficiently.",
    },
    {
      title: "At what point do I need to sign the tenancy agreement?",
      content: "Once your reference checks have been completed, you will receive a copy of the tenancy agreement. The tenancy agreement will need to be signed on or before the start date of the contract. Once all parties have signed the tenancy agreement you will then receive a set of keys to your new home.",
    },
    {
      title: "What happens to my security deposit?",
      content: "If you are moving into one of our managed properties, your deposit will be registered in a deposit protection scheme. You will also receive a copy of your deposit certificate within the first week of your tenancy.",
    },
    {
      title: "What do I need to earn per year to secure a property?",
      content: "All tenants will need to earn a combined salary of 2.5 times the annual rent to be eligible and qualified to secure a property.",
    },
  ]

  const landlords = [
    {
      title: "What lettings services do you offer?",
      content: "We offer three main service levels: Let only, Rent Collection and Fully Managed. Each involves a different degree of service in which the fees we charge reflect this.",
    },
    {
      title: "How long does it take to secure a tenant for my property?",
      content: "Whilst there is no specific time limit, this can vary depending on the property itself and the condition, also current market conditions at the time of listing the property. Normally between 2-4 weeks to ensure you have the right tenant for your property.",
    },
    {
      title: "Will I be informed when a maintenance issue arises on my property?",
      content: "Yes, you will always be made aware of all maintenance issues, you will be provided with multiple quotes and make the decision on which quote you would like to proceed with. We will never make a deduction from the rent without you being informed.",
    },
    {
      title: "What certificates do I need in place to rent my property?",
      content: "To legally rent your property in the UK, you need a valid Gas Safety Certificate, an Energy Performance Certificate (EPC), and an Electrical Installation Condition Report (EICR).",
    },
    {
      title: "Is it my responsibility as a landlord to provide furniture?",
      content: "You are not obliged to provide any furniture for your tenants, however if you did let out your property furnished then you will need to ensure the furniture is safe and the appliances are in working order.",
    },
    {
      title: "Would you advise having an inventory report done when a new tenant moves in?",
      content: "Even though it is not a legal requirement, we will strongly advise an inventory report to be done by a professional inventory clerk before your tenant moves into the property. It will help resolve any disputes/claims made in relation to the deposit.",
    },
  ];

  useEffect(() => {
    document.title = "FAQS | Zen Homes";
  }, []);
  return (
    <div className="accordionContainer">
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
     <Banner title="Frequently Asked Questions" backgroundImage={ImageFAQ}/>
    
<div className="accordionWrapperContainer">
<div className="accordionWrapper">
        <h2>Sales &#40;Vendors&#41;</h2>
        {vendors.map((item, index) => (
          <Accordion key={index} title={item.title} content={item.content} />
        ))}

      </div>
      <div className="accordionWrapper">
        <h2>Sales &#40;Buyers&#41; </h2>
        {buyers.map((item, index) => (
          <Accordion key={index} title={item.title} content={item.content} />
        ))}
      </div>
      <div className="accordionWrapper">
        <h2> Lettings &#40;Tenants&#41;</h2>
        {tenants.map((item, index) => (
          <Accordion key={index} title={item.title} content={item.content} />
        ))}
      </div>
      <div className="accordionWrapper">
        <h2> Lettings &#40;Landlords&#41;</h2>
        {landlords.map((item, index) => (
          <Accordion key={index} title={item.title} content={item.content} />
        ))}
      </div>
</div>
      
      <Footer />
    </div>
  );
}

export default Faqs;
